import PropTypes, { bool } from 'prop-types';

export const propTypes = {
  prepayTermsLink: PropTypes.element,
  oppositeEstimatedTotal: PropTypes.object,
  handleTogglePrepay: PropTypes.func,
  checked: bool,
};
